<template>
    <Tooltip :is-disabled="props.allocationCount.total === 0">
        <template #trigger="tooltipProps">
            <p
                :id="props.id"
                class="whitespace-nowrap uppercase text-xxs focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gray-700 rounded-xs tabular-nums select-none"
                :class="props.allocationCount.total > 0 ? 'cursor-help font-bold' : 'font-normal'"
                v-bind="tooltipProps"
                :tabindex="0"
            >
                {{ props.label }}
                <span v-if="props.allocationCount.total > 0" class="tabular-nums">
                    <template v-if="props.allocationCount.inRange === props.allocationCount.total">
                        ({{ props.allocationCount.total }})
                    </template>

                    <template v-if="props.allocationCount.inRange !== props.allocationCount.total">
                        ({{ props.allocationCount.inRange }}/{{ props.allocationCount.total }})
                    </template>
                </span>
            </p>
        </template>

        <template #text>
            <i18n
                v-if="props.allocationCount.inRange === props.allocationCount.total"
                path="section-contains-all-allocations"
                :args="{ count: props.allocationCount.total }"
            >
                <template #allocationCount>
                    <span class="font-semibold">
                        {{ props.allocationCount.total }}
                    </span>
                </template>
            </i18n>

            <i18n
                v-if="props.allocationCount.inRange !== props.allocationCount.total"
                path="section-contains-allocations"
                :args="{ count: props.allocationCount.inRange }"
            >
                <template #inRangeAllocationCount>
                    <span class="font-semibold">
                        {{ props.allocationCount.inRange }}
                    </span>
                </template>

                <template #totalAllocationCount>
                    <span class="font-semibold">
                        {{ props.allocationCount.total }}
                    </span>
                </template>
            </i18n>
        </template>
    </Tooltip>
</template>

<script setup lang="ts">
import Tooltip from '@/components/Tooltip/Tooltip.vue';
import type { AllocationCount } from '../logic/allocationCounts';

type SectionAllocationCountLabelProps = {
    id: string;
    label: string;
    allocationCount: AllocationCount;
};

const props = defineProps<SectionAllocationCountLabelProps>();
</script>
